import { render, staticRenderFns } from "./ExpensesReport.vue?vue&type=template&id=0dd653ee"
import script from "./ExpensesReport.vue?vue&type=script&lang=js"
export * from "./ExpensesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports